var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "booking-time-config" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-card",
                {
                  staticClass: "custom-card",
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("div", { staticClass: "card-header" }, [
                            _c("i", { staticClass: "el-icon-time" }),
                            _vm._v(" "),
                            _c("span", [_vm._v("预约时间段配置")]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c(
                    "el-form",
                    { attrs: { "label-width": "120px", size: "small" } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "启用分时段预订" } },
                        [
                          _c("el-switch", {
                            model: {
                              value: _vm.config.enabled,
                              callback: function ($$v) {
                                _vm.$set(_vm.config, "enabled", $$v)
                              },
                              expression: "config.enabled",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.config.enabled
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "scene-wrapper" },
                                [
                                  _c("span", { staticClass: "scene-label" }, [
                                    _vm._v("场景"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "el-tabs",
                                    {
                                      staticClass: "scene-tabs",
                                      on: {
                                        "tab-click": _vm.handleSceneChange,
                                      },
                                      model: {
                                        value: _vm.activeScene,
                                        callback: function ($$v) {
                                          _vm.activeScene = $$v
                                        },
                                        expression: "activeScene",
                                      },
                                    },
                                    [
                                      _c("el-tab-pane", {
                                        attrs: { label: "自提", name: "zt" },
                                      }),
                                      _vm._v(" "),
                                      _c("el-tab-pane", {
                                        attrs: { label: "外卖", name: "wm" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "sync-btn",
                                      attrs: {
                                        type: "success",
                                        size: "small",
                                        icon: "el-icon-copy-document",
                                      },
                                      on: { click: _vm.syncToOtherScenes },
                                    },
                                    [
                                      _vm._v(
                                        "\n                同步到其他场景\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.currentSceneRanges,
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      type: "index",
                                      label: "序号",
                                      width: "60",
                                      align: "center",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "name",
                                      label: "时段名称",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.editingName
                                                ? _c("el-input", {
                                                    attrs: {
                                                      placeholder: "时段名称",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.handleBlurSave(
                                                          scope.row,
                                                          "name"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.name,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "name",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.name",
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "editable-text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.startEdit(
                                                            scope.row,
                                                            "name"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.name || "-"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4138146331
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { label: "预约时间", width: "300" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.editingTime
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "time-range-edit",
                                                    },
                                                    [
                                                      _c("el-time-picker", {
                                                        attrs: {
                                                          placeholder: "开始",
                                                          format: "HH:mm",
                                                          "value-format":
                                                            "HH:mm",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .bookingStart,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "bookingStart",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.bookingStart",
                                                        },
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "separator",
                                                        },
                                                        [_vm._v("~")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("el-time-picker", {
                                                        attrs: {
                                                          placeholder: "结束",
                                                          format: "HH:mm",
                                                          "value-format":
                                                            "HH:mm",
                                                          size: "mini",
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .bookingEnd,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "bookingEnd",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.bookingEnd",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "editable-text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.startEdit(
                                                            scope.row,
                                                            "time"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .bookingStart || "-"
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            scope.row
                                                              .bookingEnd || "-"
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2663119968
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "可以预约时间",
                                      width: "240",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.editingBookable
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "bookable-time-edit",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "book-time-item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [_vm._v("从:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("el-time-picker", {
                                                            attrs: {
                                                              placeholder:
                                                                "可预约从",
                                                              format: "HH:mm",
                                                              "value-format":
                                                                "HH:mm",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .bookableStart,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "bookableStart",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.bookableStart",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "book-time-item",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "label",
                                                            },
                                                            [_vm._v("至:")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("el-time-picker", {
                                                            attrs: {
                                                              placeholder:
                                                                "可预约至",
                                                              format: "HH:mm",
                                                              "value-format":
                                                                "HH:mm",
                                                              size: "mini",
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .bookableEnd,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "bookableEnd",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.bookableEnd",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "editable-text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.startEdit(
                                                            scope.row,
                                                            "bookable"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .bookableStart ||
                                                            "-"
                                                        ) +
                                                          " ~ " +
                                                          _vm._s(
                                                            scope.row
                                                              .bookableEnd ||
                                                              "-"
                                                          )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1265004664
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "remark",
                                      label: "备注",
                                      "min-width": "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.editingRemark
                                                ? _c("el-input", {
                                                    attrs: {
                                                      placeholder: "备注",
                                                      size: "mini",
                                                    },
                                                    on: {
                                                      blur: function ($event) {
                                                        return _vm.handleBlurSave(
                                                          scope.row,
                                                          "remark"
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value: scope.row.remark,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          scope.row,
                                                          "remark",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "scope.row.remark",
                                                    },
                                                  })
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "editable-text",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.startEdit(
                                                            scope.row,
                                                            "remark"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.remark ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4161721679
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "操作",
                                      width: "80",
                                      align: "center",
                                      fixed: "right",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "text",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.deleteRow(
                                                        scope.$index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("删除")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      1409133862
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "add-btn",
                                  attrs: {
                                    type: "dashed",
                                    icon: "el-icon-plus",
                                    size: "small",
                                  },
                                  on: { click: _vm.addTimeRange },
                                },
                                [
                                  _vm._v(
                                    "\n              添加时间段\n            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isInBatchSetting
        ? _c(
            "div",
            { staticClass: "form-actions" },
            [
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.handleSubmit } },
                [_vm._v("保存配置")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }